import { trace } from 'owa-trace';
import { mutatorAction } from 'satcheljs';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { updateAccountSourceInSourcesBySourceIdMap } from '../utils/sourcesBySourceIdMapUtils';
import { getAccountAndIndexForSourceId } from '../utils/accountLookupUtils';
import type { CoprincipalAccountSource } from '../store/schema/AccountSourceList';

export type AdditionalAccountSourceProps = Pick<CoprincipalAccountSource, 'licensingMailboxInfo'>;

const setCoprincipalAdditionalPropsMutator: (
    sourceId: string,
    additionalProps: AdditionalAccountSourceProps
) => void = mutatorAction(
    'SET_COPRINCIPAL_ADDITIONAL_PROPS',
    function (sourceId: string, additionalProps: AdditionalAccountSourceProps): void {
        const store = getAccountSourceListStore();
        const accountAndIndex = getAccountAndIndexForSourceId(store, sourceId);
        if (!accountAndIndex) {
            trace.warn(
                '[source-list-store] Account not found for sourceId when setting additional account properties'
            );
            return;
        }

        const updatedAccount = {
            ...accountAndIndex.account,
            ...additionalProps,
        };

        store.sources[accountAndIndex.index] = updatedAccount;

        // Make sure the sourcesBySourceIdMap is updated with the new object by first removing the old mappings
        // and then adding the new mappings
        const sourceInArray = store.sources[accountAndIndex.index];
        updateAccountSourceInSourcesBySourceIdMap(sourceInArray);
    }
);

export default setCoprincipalAdditionalPropsMutator;
